export const jsonToQueryStringParam = (json: any) => {
  return '?' + Object.keys(json).map(key => {
    return `${key}=${json[key]}`
  }).join('&')
}
